import { createRoot } from "react-dom/client"
import { RenderApp } from "./DemoApp"
import { DemoLaunch } from "./Launch"
import { SetupIcons } from "../app/Components/Icon"

SetupIcons();
document.documentElement.setAttribute("data-theme", "dark");
const root = document.getElementById("root")!;
const { language, scene } = DemoLaunch.resolve(window.location);
RenderApp(createRoot(root), language, scene);
